<template>
  <main>
    <!-- <NavigationCard image="/assets/img/About/navigation.png" title="SANMAK LIGHTING" :showOverlay="false" /> -->
    <!-- <NavigationCard image="/assets/img/About/navigation.png" title="SANMAK LIGHTING"/> -->
     
    <NavigationCard topUrl="../../../assets/img/TopFirst/SanmakTop.mp4" topUrlType="video" />
    <div class="page_content">
      <RouteNav></RouteNav>
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </main>
</template>

<script>
// import NavigationCard from '@/components/common/NavigationCard.vue';

import NavigationCard from '@/components/common/TopVideo.vue';
import RouteNav from '@/components/common/RouteNav.vue';
export default {
  name: 'AboutUs',
  components: {
    RouteNav,
    NavigationCard
  }
}
</script>
<style scoped>
@import '../../assets/css/main.css';
</style>
